// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwTextbox from 'viewmodel/AwTextboxViewModel';
import AwBreak from 'viewmodel/AwBreakViewModel';
import AwLabel from 'viewmodel/AwLabelViewModel';
import AwFileUpload from 'viewmodel/AwFileUploadViewModel';
import AwTextarea from 'viewmodel/AwTextareaViewModel';
import AwDatetime from 'viewmodel/AwDatetimeViewModel';
import AwIconButton from 'viewmodel/AwIconButtonViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';
import { VisibleWhen, AwClass } from 'js/hocCollection';
const TrVisibleWhen = VisibleWhen('tr');
const AwButtonAwClass = AwClass(AwButton);
TrVisibleWhen.displayName = 'TrVisibleWhen';
AwButtonAwClass.displayName = 'AwButtonAwClass';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/contentFileUploadService', () => import('js/contentFileUploadService'));
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/accEventBus', () => import('js/accEventBus'));
registerDynImportEntry('js/rfqHelper', () => import('js/rfqHelper'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "data": {
    "thumbnailImage": {
      "displayName": "{{i18n.thumbnailImage}}",
      "type": "STRING",
      "isRequired": "false",
      "isEditable": "false",
      "dbValue": "",
      "dispValue": ""
    },
    "addButtonCommand": {
      "action": "addTagRow",
      "iconName": "cmdAdd24",
      "tooltip": "Add"
    },
    "removeButtonCommand": {
      "action": "removeTagRow",
      "iconName": "cmdClose16",
      "tooltip": "Remove"
    },
    "name": {
      "displayName": "{{i18n.name}}",
      "dbValue": "",
      "type": "STRING",
      "isRequired": "true",
      "isEditable": "true",
      "maxLength": 32,
      "requiredText": "{{i18n.rfqNameRequired}}",
      "validationCriteria": [{
        "condition": "conditions.invalidRfqName",
        "value": "{{i18n.invalidRfqName}}"
      }]
    },
    "description": {
      "displayName": "{{i18n.description}}",
      "type": "STRING",
      "isEditable": "true",
      "maxLength": 256,
      "numberOfLines": 3,
      "requiredText": "{{i18n.rfqDescriptionOptional}}"
    },
    "dueDate": {
      "displayName": "{{i18n.dueDate}}",
      "type": "DATETIME",
      "isRequired": "true",
      "isEditable": "true",
      "dbValue": "",
      "labelPosition": "PROPERTY_LABEL_AT_SIDE"
    },
    "tagName": {
      "displayName": "{{i18n.name}}",
      "dbValue": "",
      "type": "STRING",
      "isRequired": "false",
      "isEditable": "false",
      "maxLength": 32
    },
    "tagValue": {
      "displayName": "{{i18n.value}}",
      "dbValue": "",
      "type": "STRING",
      "isRequired": "false",
      "isEditable": "false",
      "maxLength": 32
    }
  },
  "props": {
    "accsessionid": {
      "type": "string"
    },
    "collaborationspaceid": {
      "type": "string"
    },
    "parentprojectid": {
      "type": "string"
    },
    "disabletags": {
      "type": "boolean"
    }
  },
  "actions": {
    "performCreateBatchAction": {
      "actionType": "batchJob",
      "steps": [{
        "action": "validateAndGetTags"
      }, {
        "action": "createRfq"
      }, {
        "action": "uploadFileToServer"
      }]
    },
    "uploadFileToServer": {
      "actionType": "JSFunctionAsync",
      "method": "sendDssFileToUpload",
      "inputData": {
        "accsessionid": "{{ctx.rfq?.accsessionid || props.accsessionid}}",
        "accUrl": "{{data.accUrl}}",
        "ticketIds": "[{{parameters.thumbnailUploadTicket}}]",
        "formData": "{{data.fileInputForms}}",
        "stagingAreaId": "",
        "csId": "{{ctx.rfq?.collaborationspaceid || props.collaborationspaceid}}",
        "rfqId": ""
      },
      "events": {
        "success": [{
          "name": "thumbnail.fileUploaded"
        }]
      },
      "deps": "js/contentFileUploadService"
    },
    "createRfq": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "mutation CreateRfq( $collaborationspaceId: String, $createRfqInput: Json) { createRfq( collaborationspaceId: $collaborationspaceId, createRfqInput: $createRfqInput ) }",
            "variables": {
              "collaborationspaceId": "{{ctx.rfq.collaborationspaceid || props.collaborationspaceid}}",
              "createRfqInput": {
                "name": "{{data.name.dbValue}}",
                "description": "{{data.description.dbValue}}",
                "dueDate": "{{data.dueDate.dbValue}}",
                "tags": "{{data.tags}}",
                "fileNames": "{{data.fileNames}}"
              }
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{ctx.rfq.accsessionid || props.accsessionid}}"
      },
      "outputData": {
        "errorCode": "errorCode",
        "rfqCreated": "createdRfq",
        "accUrl": "url"
      },
      "events": {
        "success": [{
          "name": "create-rfq.success",
          "eventData": {
            "rfqCreated": "{{rfqCreated}}"
          }
        }, {
          "condition": "rfqCreated.rfqId",
          "name": "create-rfq.success",
          "eventData": {
            "rfqCreated": "{{rfqCreated}}"
          }
        }, {
          "condition": "rfqCreated.error === 'EMPTY_COLLAB_SPACE'",
          "name": "create-rfq.error",
          "eventData": {
            "error": "{{i18n.EMPTY_COLLAB_SPACE}}",
            "errorCode": 400
          }
        }, {
          "condition": "rfqCreated.error.statusCode === 400 || errorCode === 400",
          "name": "create-rfq.error",
          "eventData": {
            "error": "{{rfqCreated.error}}",
            "errorCode": 400
          }
        }, {
          "condition": "rfqCreated.error.statusCode === 403 || errorCode === 403",
          "name": "create-rfq.error",
          "eventData": {
            "error": "{{i18n.FORBIDDEN}}",
            "errorCode": 403
          }
        }, {
          "condition": "rfqCreated.error.statusCode === 401 || errorCode === 401 || errorCode === 'INVALID_ACC_SESSION_ID'",
          "name": "create-rfq.error",
          "eventData": {
            "error": "{{i18n.UNAUTHORIZED}}",
            "errorCode": 401
          }
        }, {
          "condition": "rfqCreated.error.statusCode >= 500 && rfqCreated.error.statusCode <= 599",
          "name": "create-rfq.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }],
        "failure": [{
          "name": "create-rfq.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }]
      },
      "deps": "js/accHttpService"
    },
    "publishToACCEventBus": {
      "actionType": "JSFunction",
      "method": "publish",
      "inputData": {
        "eventId": "{{parameters.eventId}}",
        "eventData": "{{parameters.eventData}}"
      },
      "deps": "js/accEventBus"
    },
    "updateSelectedFileInfoAction": {
      "actionType": "JSFunction",
      "method": "getSelectedFileInfo",
      "inputData": {
        "fileName": "{{parameters.fileName}}",
        "formData": "{{parameters.formData}}",
        "parameters": "{{parameters}}",
        "maxFilesAllowed": 1
      },
      "outputData": {
        "fileInputForms": "fileInputForms",
        "fileNames": "fileNames",
        "maxFileExceeded": "maxFileExceeded"
      },
      "events": {
        "success": [{
          "condition": "maxFileExceeded",
          "name": "maxFileExceededError"
        }]
      },
      "deps": "js/contentFileUploadService"
    },
    "addTagRow": {
      "actionType": "JSFunction",
      "method": "addTagRow",
      "deps": "js/rfqHelper",
      "inputData": {},
      "outputData": {}
    },
    "removeTagRow": {
      "actionType": "JSFunction",
      "method": "removeTagRow",
      "deps": "js/rfqHelper",
      "inputData": {},
      "outputData": {}
    },
    "validateAndGetTags": {
      "actionType": "JSFunction",
      "method": "validateAndGetTags",
      "deps": "js/rfqHelper",
      "inputData": {
        "disabletags": "{{props.disabletags}}",
        "parentprojectid": "{{props.parentprojectid}}"
      },
      "outputData": {
        "tags": "tags",
        "errorRows": "errorRows"
      },
      "events": {
        "success": [{
          "condition": "errorRows.length > 0",
          "name": "validateTags.error",
          "eventData": {
            "error": "Tags error",
            "errorCode": 400,
            "errorRows": "{{errorRows}}"
          }
        }]
      }
    }
  },
  "onEvent": [{
    "eventId": "maxFileExceededError",
    "message": "maxFileExceededError"
  }, {
    "eventId": "validateTags.success",
    "action": "createRfq"
  }, {
    "eventId": "validateTags.error",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-create-rfq.error",
      "eventData": "{{eventData}}"
    }
  }, {
    "eventId": "thumbnail.fileUploaded",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "thumbnail.fileUploaded.success"
    }
  }, {
    "eventId": "create-rfq.success",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-create-rfq.success",
      "eventData": "{{eventData.rfqCreated}}"
    }
  }, {
    "eventId": "create-rfq.error",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-create-rfq.error",
      "eventData": {
        "message": "{{eventData.error}}",
        "statusCode": "{{eventData.errorCode}}"
      }
    }
  }],
  "lifecycleHooks": {
    "onMount": ""
  },
  "conditions": {
    "validInput": {
      "expression": "data.name.dbValue && !conditions.invalidRfqName && !data.maxFileExceeded"
    },
    "invalidRfqName": {
      "expression": "!(/^[a-zA-Z\\d-_ ]+$/.test(data.name.dbValue))"
    },
    "showTagsOptions": {
      "expression": "props.disabletags === null || props.disabletags === undefined || !props.disabletags"
    }
  },
  "messages": {
    "maxFileExceededError": {
      "messageType": "WARNING",
      "messageText": "Cannot add more than 1 thumbnail."
    }
  },
  "i18n": {
    "Create": ["RfqMessages"],
    "thumbnailImage": ["RfqMessages"],
    "name": ["RfqMessages"],
    "value": ["RfqMessages"],
    "dueDate": ["RfqMessages"],
    "description": ["RfqMessages"],
    "rfqNameRequired": ["RfqMessages"],
    "rfqDueDateRequired": ["RfqMessages"],
    "rfqDescriptionOptional": ["RfqMessages"],
    "invalidRfqName": ["RfqMessages"],
    "ACC_SERVER_ERROR": ["errorMessages"],
    "EMPTY_COLLAB_SPACE": ["errorMessages"],
    "BAD_REQUEST_CREATE_RFQ": ["errorMessages"],
    "FORBIDDEN": ["errorMessages"],
    "UNAUTHORIZED": ["errorMessages"]
  },
  "_viewModelId": "CreateRfq",
  "_uniqueViewModelId": "CreateRfq",
  "ctx": {
    "rfq": {
      "type": "object"
    }
  }
};

/*
<div class="afx-content-background aw-layout-full sw-column">
    <form id="upload" action="/upload" method="post" enctype="multipart/form-data">
    <table height="">
        <tr class="tableBody">
            <td>
                <aw-textbox prop="data.name"></aw-textbox>
                <aw-break></aw-break>
                <aw-label prop="data.thumbnailImage"></aw-label>
                <aw-file-upload file-change-action="updateSelectedFileInfoAction" multiple="{{true}}" remove-tooltip="{{i18n.thumbnailImage}}"></aw-file-upload>
                <aw-break></aw-break>
                <aw-textarea prop="data.description"></aw-textarea>
                <aw-datetime prop="data.dueDate"></aw-datetime>
            </td>
        </tr>
        <tr visible-when="conditions.showTagsOptions">
            <td>
                <table id="tagsTable">
                    <tr>
                        <td class="leftAlign"><aw-label prop="data.tagName"></aw-label></td>
                        <td class="leftAlign"><aw-label prop="data.tagValue"></aw-label></td>
                        <td class="leftAlign"><aw-icon-button command="data.addButtonCommand"></aw-icon-button></td>
                        <td class="leftAlign"><aw-icon-button command="data.removeButtonCommand"></aw-icon-button></td>
                    </tr>
                    <tr id="row1">
                        <td>
                            <input class="sw-property-val" id="tagName" type="text">
                        </td>
                        <td>
                            <input class="sw-property-val" id="tagValue" type="text">
                        </td>
                        <td></td>
                        <td></td>
                    </tr>
                </table>
            </td>                        
        </tr>
    </table>
</form>
<table>
    <tr class="tableFooter">
        <td>
            <aw-break></aw-break>
            <aw-button aw-class="{'disabled': !conditions.validInput}" action="performCreateBatchAction" size="auto">{{i18n.Create}}</aw-button>            
        </td>
    </tr>
</table>
</div>

*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement("div", {
    className: "afx-content-background aw-layout-full sw-column"
  }, /*#__PURE__*/React.createElement("form", {
    id: "upload",
    action: "/upload",
    method: "post",
    encType: "multipart/form-data"
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", {
    className: "tableBody"
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(AwTextbox, getField("data.name", fields, $index, null, null)), /*#__PURE__*/React.createElement(AwBreak, null), /*#__PURE__*/React.createElement(AwLabel, getField("data.thumbnailImage", fields, $index, null, null)), /*#__PURE__*/React.createElement(AwFileUpload, {
    dndHandler: props.viewModel.dndHandler,
    fileChangeAction: actions.updateSelectedFileInfoAction,
    multiple: AwParseService.instance("true")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    removeTooltip: AwParseService.instance("i18n.thumbnailImage")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }), /*#__PURE__*/React.createElement(AwBreak, null), /*#__PURE__*/React.createElement(AwTextarea, getField("data.description", fields, $index, null, null)), /*#__PURE__*/React.createElement(AwDatetime, getField("data.dueDate", fields, $index, null, null)))), /*#__PURE__*/React.createElement(TrVisibleWhen, {
    visibleWhen: AwParseService.instance("conditions.showTagsOptions")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("table", {
    id: "tagsTable"
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "leftAlign"
  }, /*#__PURE__*/React.createElement(AwLabel, getField("data.tagName", fields, $index, null, null))), /*#__PURE__*/React.createElement("td", {
    className: "leftAlign"
  }, /*#__PURE__*/React.createElement(AwLabel, getField("data.tagValue", fields, $index, null, null))), /*#__PURE__*/React.createElement("td", {
    className: "leftAlign"
  }, /*#__PURE__*/React.createElement(AwIconButton, getField("data.addButtonCommand", fields, $index, null, null))), /*#__PURE__*/React.createElement("td", {
    className: "leftAlign"
  }, /*#__PURE__*/React.createElement(AwIconButton, getField("data.removeButtonCommand", fields, $index, null, null)))), /*#__PURE__*/React.createElement("tr", {
    id: "row1"
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("input", {
    className: "sw-property-val",
    id: "tagName",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("input", {
    className: "sw-property-val",
    id: "tagValue",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null))))))))), /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", {
    className: "tableFooter"
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(AwBreak, null), /*#__PURE__*/React.createElement(AwButtonAwClass, {
    action: actions.performCreateBatchAction,
    size: "auto",
    awClass: AwParseService.instance("{'disabled': !conditions.validInput}")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, AwParseService.instance("i18n.Create")({
    props,
    data,
    fields,
    dataProviders,
    ctx,
    i18n,
    actions,
    subPanelContext,
    viewPath,
    conditions,
    formProp,
    dispatch,
    selectionModels,
    editHandlers,
    chartProviders,
    ports
  })))))));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;